export const getEvent = state => state.winston;